module.exports = __webpack_public_path__ + "static/logo-team-liquid-e7111a3f6ccd9d509a55748af3f531f6.svg";